/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useState, useEffect } from "react";
import useStyles from "./styles";
import NoneData from "components/NoneData";
import DialogSuccess from "./Components/DialogSuccess";
import clsx from "clsx";

import { Grid, Checkbox, Button, IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
	signature,
	getFileTimelineCRM,
	postConfirmTimelineCRM
} from "store/actions/SignatureAction";
import { getCRMShopInfoDetail } from "store/actions/HomePageAction";
import { pdfjs, Document, Page } from "react-pdf";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {
	ArrowBackIos,
	ArrowForwardIos,
	ZoomIn,
	ZoomOut
} from "@material-ui/icons";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const SignaturePage = memo(props => {
	const { infoShop, getFileTimelineCRM, urlTimeline, confirmTimelineCRM } =
		props;
	const classes = useStyles();
	const history = useHistory();
	const [isCheck, setCheck] = useState(false);

	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [open, setOpen] = useState(false);

	function onDocumentLoadSuccess({ numPages }) {
		setNumPages(numPages);
		setPageNumber(1);
	}

	const onNextPage = () => {
		pageNumber < numPages && setPageNumber(pageNumber + 1);
	};

	const onPrevPage = () => {
		pageNumber > 1 && setPageNumber(pageNumber - 1);
	};

	let isSignature = infoShop?.isSignature || false;

	const handleChange = event => {
		setCheck(event.target.checked);
	};

	useEffect(() => {
		getFileTimelineCRM();
	}, []);

	const onSuccess = () => {
		setOpen(true);
		getCRMShopInfoDetail();
	};

	const handleSubmit = () => {
		const params = {
			isConfirm: isCheck,
			onSuccess
		};
		confirmTimelineCRM(params);
	};

	const handleCancel = () => {
		history.goBack();
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<DialogSuccess
				open={open}
				handleClose={() => {
					setOpen(false);
					history.push("/user");
				}}
			/>
			{!!urlTimeline ? (
				<React.Fragment>
					<TransformWrapper
						defaultScale={1}
						defaultPositionX={200}
						defaultPositionY={100}
					>
						{({ zoomIn, zoomOut, resetTransform, ...rest }) => (
							<React.Fragment>
								<TransformComponent>
									<Document
										file={urlTimeline}
										onLoadSuccess={onDocumentLoadSuccess}
										className={classes.documnet}
									>
										<Page pageNumber={pageNumber} />
									</Document>
								</TransformComponent>
								<Grid
									classes={{
										root: clsx(
											classes.footerPdf,
											infoShop?.isSignature &&
												classes.footerPdfConfirmed
										)
									}}
								>
									<IconButton onClick={() => zoomOut()}>
										<ZoomOut style={{ fontSize: 20 }} />
									</IconButton>
									<IconButton onClick={() => onPrevPage()}>
										<ArrowBackIos
											style={{ fontSize: 12 }}
										/>
									</IconButton>
									<Grid>
										Trang {pageNumber} của {numPages}
									</Grid>
									<IconButton onClick={() => onNextPage()}>
										<ArrowForwardIos
											style={{ fontSize: 12 }}
										/>
									</IconButton>

									<IconButton onClick={() => zoomIn()}>
										<ZoomIn style={{ fontSize: 20 }} />
									</IconButton>
								</Grid>
							</React.Fragment>
						)}
					</TransformWrapper>

					{!infoShop?.isSignature && (
						<React.Fragment>
							<Grid classes={{ root: classes.rootChecked }}>
								<Checkbox
									classes={{
										checked: isSignature
											? classes.checkedDisabledRadio
											: classes.checkedRadio,
										root: classes.rootRadio
									}}
									checked={
										isSignature ? isSignature : isCheck
									}
									disabled={isSignature}
									onChange={handleChange}
									color="primary"
									inputProps={{
										"aria-label": "secondary checkbox"
									}}
								/>{" "}
								<span>
									Tôi đồng ý các điều khoản và xác nhận tham
									gia chương trình khách hàng CRM 2023 của
									Công Ty Cổ Phần Tập Đoàn KIDO.
								</span>
							</Grid>

							<Grid style={{ textAlign: "center" }}>
								<Grid style={{ marginTop: 10 }}>
									<Button
										onClick={() => {
											handleSubmit();
										}}
										color="primary"
										variant="contained"
										disabled={!isCheck}
										classes={{ root: classes.btnSubmit }}
									>
										Xác nhận
									</Button>
								</Grid>
								<Grid
									style={{ marginTop: 10, marginBottom: 10 }}
								>
									<Button
										onClick={() => {
											handleCancel();
										}}
										classes={{ root: classes.btnCancel }}
										variant="outlined"
									>
										Huỷ
									</Button>
								</Grid>
							</Grid>
						</React.Fragment>
					)}
				</React.Fragment>
			) : (
				<NoneData />
			)}
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop,
		urlTimeline: state.signaturePageReducer.urlTimeline
	};
};

const mapDispatchToProps = dispatch => {
	return {
		signatureAction: data => {
			dispatch(signature(data));
		},
		getCRMShopInfoDetail: () => {
			dispatch(getCRMShopInfoDetail());
		},
		getFileTimelineCRM: () => {
			dispatch(getFileTimelineCRM());
		},
		confirmTimelineCRM: data => {
			dispatch(postConfirmTimelineCRM(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SignaturePage);
